module.exports = __webpack_public_path__ + "img/ai.439212b4.svg";